(function () {
    'use strict';

    angular
        .module('app')
        .controller('loginModalController', loginModalController);

    function loginModalController($rootScope, $scope, $uibModalInstance, loginService, $location, modalService,
        enumService, e2eService, mobileService, translateService, iAmNotRobot) {
        // console.log("iAmNotRobot:",iAmNotRobot);
        var vm = this;
        vm.isMobile = modalService.isMobile();
        vm.iAmNotRobot = iAmNotRobot;
        vm.cancel = cancel;
        vm.submit = submit;
        vm.autoFill = autoFill;
        vm.autoFill2 = autoFill2;
        vm.openForgetPwd = openForgetPwd;
        vm.openRegister = openRegister;
        vm.openExplanation = openExplanation;
        //vm.enableLogin = enableLogin;
        vm.deviceToken = deviceToken;

        // virtual kb need
        vm.isInitKeyboard = false;
        vm.showVirKey = showVirKey;
        vm.isShowVirKey = false;
        vm.pwdChanged = pwdChanged;
        vm.focusObj = null;
        vm.virData = null;

        // ------------------------
        // 針對哪個 input 使用動態鍵盤輸入
        vm.getFocusUserAccount = function () {
            vm.focusObj = "userAccount";
            //vm.virData = vm.login.userAccount;    //2019-09-23 修正focus：TypeError: 無法取得未定義或 Null 參考的屬性 'userAccount'
        }
        vm.getFocusUserPwd = function () {
            vm.focusObj = "userPwd";
            //vm.virData = vm.login.pwd;    //2019-09-23 修正focus：TypeError: 無法取得未定義或 Null 參考的屬性 'pwd'
        }
        vm.enableLogin = function () {
            enableLogin;
        }

        function pwdChanged(newPwd) {
            if(vm.focusObj == null)     //2019-09-23 修正未指定focus造成錯誤：修正為NULL帶預設欄位為帳號
                vm.focusObj = "userAccount";
            
            var e = document.getElementById(vm.focusObj);
            e.value = newPwd;
            var $e = angular.element(e);
            $e.triggerHandler('input');
            
        }

        function showVirKey() {
            if (vm.isShowVirKey)
                vm.isShowVirKey = false;
            else
                vm.isShowVirKey = true;
        }

        // -----------------------

        // 測試是否有抓到 Device Token
        function deviceToken() {
            let myDeviceToken = "device token is empty";
            if (DEVICE_TOKEN) {
                myDeviceToken = DEVICE_TOKEN;
            }
            return myDeviceToken;
        }

        vm.view = {
            loginBefore: false
        };
        //讀入Google reCaptcha需要的key

        
        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function specialKeywordVerificationUserAccount(keyWord){
            /*2020-06-11 Johnson
            特殊字元 【\】【/】【<】【>】【'】【"】【(】【)】【%】
            問題單：2020/05/13  2020 APP滲透測試報告
            https://app.asana.com/0/742244134012369/1175524709436847
            */
            keyWord = keyWord.replace(/\\/g,"/");
            var pattern = new RegExp("[/\\/<>'\"()%]");
            var result = false; 
            for (var i = 0; i < keyWord.length; i++) {
                console.log('for keyWord:'+keyWord.substr(i, 1) +' pattern:'+keyWord.substr(i, 1).replace(pattern, 'false'));
                if (keyWord.substr(i, 1).replace(pattern, 'false') == "false") {result=true; }
            } 
            return result;
        }

        function specialKeywordVerification(keyWord){
            /*2020-06-11 Johnson
            特殊字元 【\】【/】【<】【>】【'】【"】【(】【)】【%】【.】
            問題單：2020/05/13  2020 APP滲透測試報告
            https://app.asana.com/0/742244134012369/1175524709436847
            */
            keyWord = keyWord.replace(/\\/g,"/");
            var pattern = new RegExp("[/\\/<>'\"()%.]");
            var result = false; 
            for (var i = 0; i < keyWord.length; i++) {
                console.log('for keyWord:'+keyWord.substr(i, 1) +' pattern:'+keyWord.substr(i, 1).replace(pattern, 'false'));
                if (keyWord.substr(i, 1).replace(pattern, 'false') == "false") {result=true; }
            } 
            return result;
        }

        function submit() {

            if(specialKeywordVerificationUserAccount(vm.login.userAccount))
            {
                toastr.warning($rootScope.translate.tsdgLoginAccount + $rootScope.translate.specialKeywords);
                return false;
            }
            else if(specialKeywordVerification(vm.login.inputVerify))
            {
                toastr.warning($rootScope.translate.validateCode + $rootScope.translate.specialKeywords);
                return false;
            }

            if($('#inputVerify').val().length == 4){
                
                
                var paramsLogin = {
                    userAccount: btoa(vm.login.userAccount),
                    pwd: btoa(vm.login.pwd),
                    inputVerify: $('#inputVerify').val().toUpperCase(),
                    isPass: $('#isPass').val(),
                    SecretKey: "1"
                };
                
                //console.log("submit pass");
                //已在SP中統一做大小寫比較
                // if (vm.login.userAccount.indexOf('@') >= 0){
                //    vm.login.userAccount = vm.login.userAccount.toLowerCase();
                // }
                // console.log('vm:', vm);
                // console.log('vm.login:', vm.login);
                // console.log(' vm.login.isPass:',  vm.login.isPass);
                
                loginService.login(paramsLogin).then(function (data) {
                    if (data) {
                        if (data.length > 1) {
                            var result = modalService.getChoicePerSerilNo(data);
                            result.result.then(function (item) {
                                var params = {
                                    pwd: vm.login.pwd,
                                    perSerilNo: item.PerserilNo,
                                    userAccount: item.UserAccount
                                };
                                loginService.loginByPerSerilNo(params).then(function (data) {
                                    if (data) {
                                        loginToEditOrHome(data);
                                        mobileService.postMobileInfo(data);
                                    }
                                });
                            });
                        } else {
                            //console.log('sso item:',data);
                            loginToEditOrHome(data);
                            mobileService.postMobileInfo(data);
                        }
                        vm.view.loginBefore = false;
                        return data;
                    } else if(!data === undefined){
                        toastr.warning($rootScope.translate.commonReCaptchaFail);
                        //2023-07-13 Johnson 資安2023
                        vm.login.pwd = eval(function(p,a,c,k,e,r){e=String;if(!''.replace(/^/,String)){while(c--)r[c]=k[c]||c;k=[function(e){return r[e]}];e=function(){return'\\w+'};c=1};while(c--)if(k[c])p=p.replace(new RegExp('\\b'+e(c)+'\\b','g'),k[c]);return p}('0;',2,1,'null'.split('|'),0,{}))

                    }
                }).catch(() => {
                    vm.view.loginBefore = false;
                });


            }else
            {
                toastr.warning($rootScope.translate.commonReCaptchaFail);
            }
           
        }

        /**
         * 判斷要登入到首頁或強制修改密碼頁
         * 
         * @param data (description)
         */
        function loginToEditOrHome(data) {
            setSsoInfo(data);
            $uibModalInstance.close('ok');
            $('#captcha iframe').empty().remove();
            translateService.getLanguage().then(function (languageItems) {
                var defaultLangItem = _.find(languageItems.data, {
                    selected: true
                });
                translateService.change(defaultLangItem);
                if (data.IsForce) {
                    sessionStorage.setItem('isForce', true);
                    $location.path('/login/forceEditPwd');
                } else if (data.isFirstLogin) {
                    modalService.phoneNumber();
                } else {
                    $location.path('/').search('menu', 31);
                }
            });
        }

        function autoFill() {
            vm.login = {};
            e2eService.login(vm.login);
            //debugger;
            //var result = loginService.QueryCaptcha();

        }
        function autoFill2() {
            vm.login = {};
            e2eService.login(vm.login);
            //debugger;
            //var result = loginService.chkCaptcha();

        }
        function openForgetPwd() {
            modalService.forgetPwd();
        }

        function openRegister() {
            modalService.register();
        }

        function openExplanation() {
            modalService.explanation();
        }

        function enableLogin() {
            vm.view.loginBefore = false;
        }


    }
})();